import {axios} from "@/api/config";
// 查询风险分析单元管理列表
export function listRiskUnitStop(params) {
  return axios.get(`/riskUnitStop/list`, params, true);
}

// 查询风险分析单元管理详细
export function getRiskUnitStop(riskUnitStopId) {
  return axios.get(`/riskUnitStop/${riskUnitStopId}`, riskUnitStopId, true)
}

// 新增风险分析单元管理
export function addRiskUnitStop(params) {
  return axios.post('/riskUnitStop/addRiskUnitStop', params, false);
}

// 修改风险分析单元管理
export function updateRiskUnitStop(params) {
  return axios.post('/riskUnitStop/editRiskUnitStop', params, false);
}


// 删除风险分析单元管理
export function delRiskUnitStop(riskUnitStopId) {
  return axios.delete(`/riskUnitStop/${riskUnitStopId}`, true)
}

